import { createSlice } from '@reduxjs/toolkit';
import { FULLFILLED } from '@root/constants';
import { GET_ADMIN_USER_BY_ID_ACTION } from '@root/store/action-types/admin/userManagement';


const INITIAL_STATE = {
    sidebar: false,
    drawerUser: {},
    drawerPendingTransaction: {},
    requestDrawer: {},
};

export const appSlice = createSlice({
    name: 'app',
    initialState: INITIAL_STATE,
    reducers: {
        updateSidebar: (state, { payload }) => {
            state.sidebar = payload
        },
        updateDrawerPendingTransaction: (state, { payload }) => {
            state.drawerPendingTransaction = payload
        },
        updateRequestDrawer: (state, { payload }) => {
            state.requestDrawer = payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(`${GET_ADMIN_USER_BY_ID_ACTION}${FULLFILLED}`, (state, { payload }: any) => {
            state.drawerUser = payload
        });
    }
});

export const {
    updateSidebar,
    updateDrawerPendingTransaction,
    updateRequestDrawer
} = appSlice.actions;

export const adminAppReducer = appSlice.reducer;
